<template>
  <!-- BEGIN: Main Menu-->
  <!--begin::Sidebar-->
  <div
    ref="sidebarRef"
    id="kt_app_sidebar"
    class="app-sidebar flex-column"
    data-kt-drawer="true"
    data-kt-drawer-name="app-sidebar"
    data-kt-drawer-activate="{default: true, lg: false}"
    data-kt-drawer-overlay="true"
    data-kt-drawer-width="225px"
    data-kt-drawer-direction="start"
    data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
  >
    <!--begin::Logo-->
    <div class="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
      <!--begin::Logo image-->
      <a href="/">
        <img
          alt="Logo"
          src="/assets/img/acad-logo.png"
          class="h-75px app-sidebar-logo-default"
        />
        <img
          alt="Logo"
          src="/assets/img/green-icon.png"
          class="h-35px app-sidebar-logo-minimize"
        />
      </a>
      <!--end::Logo image-->
      <!--begin::Sidebar toggle-->
      <div
        id="kt_app_sidebar_toggle"
        class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
        data-kt-toggle="true"
        data-kt-toggle-state="active"
        data-kt-toggle-target="body"
        data-kt-toggle-name="app-sidebar-minimize"
      >
        <!--begin::Svg Icon | path: icons/duotune/arrows/arr079.svg-->
        <span class="svg-icon svg-icon-2 rotate-180">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.5"
              d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z"
              fill="currentColor"
            />
            <path
              d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <!--end::Svg Icon-->
      </div>
      <!--end::Sidebar toggle-->
    </div>
    <!--end::Logo-->
    <!--begin::sidebar menu-->
    <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
      <!--begin::Menu wrapper-->
      <div
        id="kt_app_sidebar_menu_wrapper"
        class="app-sidebar-wrapper hover-scroll-overlay-y my-5"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
      >
        <!--begin::Menu-->
        <div
          class="menu menu-column menu-rounded menu-sub-indention px-3"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <!--begin:Menu item-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/home">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-home"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title">{{ $t("menu.home") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--begin:Menu item - Messages/Chat-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" :to="{ name: 'ChatInbox' }">
              <span class="menu-icon">
                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-comments"></i>
                </span>
              </span>
              <span class="menu-title">{{ $t("menu.messages") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--begin:Menu item - MIA AI-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/ai-v2">
              <span class="menu-icon">
                <span class="svg-icon svg-icon-2">
                  <img src="/assets/img/mia_icon.png" alt="Mia" class="mia-icon-sidebar" />
                </span>
              </span>
              <span class="menu-title">{{ $t("menu.mia") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--begin:Menu item - MIA AI V2-->

          <!--end::Menu-->
          <!--begin:Menu item-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/Dashboard">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-book"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title">{{ $t("menu.my_courses") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--begin:Menu item-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/Wallet">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-wallet"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title">{{ $t("menu.wallet") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/courses">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-list"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title">{{ $t("menu.categories") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--begin:Menu item - Instructors-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/instructors">
              <span class="menu-icon">
                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-chalkboard-teacher"></i>
                </span>
              </span>
              <span class="menu-title">{{ $t("menu.instructors") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!-- Scholarships & Events -->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/scholar-ships">
              <span class="menu-icon">
                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-graduation-cap"></i>
                </span>
              </span>
              <span class="menu-title">{{
                $t("menu.scholarships_events")
              }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--end::Menu-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/Cart">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fa-solid fa-cart-shopping"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title">{{ $t("menu.cart") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/qbank">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-university"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title">{{ $t("menu.qbank") }}</span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/Settings">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fa-solid fa-cog"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title"> {{ $t("common.settings") }} </span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--end::Menu-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/privacy-policy">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-user-shield"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title"> {{ $t("menu.privacy") }} </span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--end::Menu-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/terms-of-service">
              <span class="menu-icon">
                <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->

                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-file-contract"></i>
                </span>
                <!--end::Svg Icon-->
              </span>
              <span class="menu-title"> {{ $t("menu.terms") }} </span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
          <!--begin:Menu item-->
          <div class="menu-item">
            <!--begin:Menu link-->
            <router-link class="menu-link" to="/account-deletion">
              <span class="menu-icon">
                <span class="svg-icon svg-icon-2">
                  <i class="fas fa-user-slash"></i>
                </span>
              </span>
              <span class="menu-title">
                {{ $t("menu.account_deletion") }}
              </span>
            </router-link>
            <!--end:Menu link-->
          </div>
          <!--end::Menu-->
        </div>
      </div>
      <!--end::Menu wrapper-->
    </div>
    <!--end::sidebar menu-->
    <!--begin::Footer-->
    <div
      class="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6"
      style="padding-bottom: 5.5rem !important"
      id="kt_app_sidebar_footer"
    >
      <a
        v-if="isLoggedIn == true"
        href="/logout"
        class="btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100"
      >
        <span class="btn-label text-danger">
          {{ $t("common.logout") }} <i class="fas fa-sign-out"></i>
        </span>
        <!--begin::Svg Icon | path: icons/duotune/general/gen005.svg-->
        <span class="svg-icon btn-icon svg-icon-2 m-0">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.3"
              d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z"
              fill="currentColor"
            />
            <rect
              x="7"
              y="17"
              width="6"
              height="2"
              rx="1"
              fill="currentColor"
            />
            <rect
              x="7"
              y="12"
              width="10"
              height="2"
              rx="1"
              fill="currentColor"
            />
            <rect x="7" y="7" width="6" height="2" rx="1" fill="currentColor" />
            <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor" />
          </svg>
        </span>
        <!--end::Svg Icon-->
      </a>
    </div>
    <!--end::Footer-->
  </div>
  <!--end::Sidebar-->
  <!-- END: Main Menu-->
</template>

<script>
import {
  apiUrl,
  courseImagePath,
  deviceId,
  getBrowserName,
  api_get,
  api,
  instructorImagePath,
} from "@/utils/api"; // Adjust the import path according to your project structure
import { walletState } from "@/stores/wallet";

export default {
  name: "SidebarComponent",
  data() {
    return {
      isloading: true,
      token: localStorage.getItem("access_token"),
      isLoggedIn: false,
    };
  },
  mounted() {
    this.scrollToActiveItem();
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.scrollToActiveItem();
      });
    },
  },
  computed: {
    isLoggedIn() {
      // Use same logic as Header: user is logged in if wallet balance was successfully fetched
      return walletState.walletBalance !== null;
    },
  },
  methods: {
    scrollToActiveItem() {
      const sidebar = this.$refs.sidebarRef;
      if (!sidebar) return;
      const activeLink = sidebar.querySelector(
        ".menu-link.router-link-active, .menu-link.router-link-exact-active"
      );
      if (activeLink) {
        activeLink.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
  },
};
</script>

<style scoped>
/* ========== Sidebar Container - Always Dark ========== */
.app-sidebar {
  background: linear-gradient(180deg, #0d1117 0%, #161b22 100%) !important;
  border-right: 1px solid rgba(0, 224, 80, 0.12) !important;
  box-shadow: 2px 0 15px rgba(0, 0, 0, 0.3) !important;
  overflow: visible !important;
  scrollbar-gutter: stable both-edges;
}

/* ========== Logo Section ========== */
.app-sidebar-logo {
  padding: 16px 12px !important;
  border-bottom: 1px solid rgba(0, 224, 80, 0.08);
}

.app-sidebar-logo img {
  filter: drop-shadow(0 0 6px rgba(0, 224, 80, 0.2));
}

/* ========== Toggle Button ========== */
#kt_app_sidebar_toggle {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 224, 80, 0.3) !important;
  z-index: 100 !important;
  position: absolute !important;
}

#kt_app_sidebar_toggle .svg-icon {
  color: #0d1117 !important;
}

/* ========== Menu Wrapper ========== */
.app-sidebar-menu {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.app-sidebar-wrapper {
  padding: 4px 0;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* ========== Menu Items ========== */
.menu-item {
  margin: 2px 8px;
}

.menu-link {
  display: flex;
  align-items: center;
  padding: 8px 12px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  gap: 10px;
}

.menu-link:hover {
  background: rgba(0, 224, 80, 0.1) !important;
}

.menu-link.active,
.menu-link.router-link-active,
.menu-link.router-link-exact-active {
  background: rgba(0, 224, 80, 0.18) !important;
  border-right: 3px solid #00e050 !important;
}

.menu-link.active .menu-icon .svg-icon,
.menu-link.router-link-active .menu-icon .svg-icon,
.menu-link.router-link-exact-active .menu-icon .svg-icon {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
}

.menu-link.active .menu-icon .svg-icon i,
.menu-link.router-link-active .menu-icon .svg-icon i,
.menu-link.router-link-exact-active .menu-icon .svg-icon i {
  color: #0d1117 !important;
}

.menu-link.active .menu-title,
.menu-link.router-link-active .menu-title,
.menu-link.router-link-exact-active .menu-title {
  color: #00e050 !important;
  font-weight: 600 !important;
}

/* ========== Menu Icons ========== */
.menu-icon {
  margin-left: 0;
  flex-shrink: 0;
}

.menu-icon .svg-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
}

.menu-icon .svg-icon i {
  font-size: 0.95rem;
  color: #ffffff;
}

.menu-link:hover .menu-icon .svg-icon {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
}

.menu-link:hover .menu-icon .svg-icon i {
  color: #0d1117;
}

/* ========== Menu Title ========== */
.menu-title {
  font-weight: 500;
  font-size: 0.9rem;
  color: #c9d1d9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-link:hover .menu-title {
  color: #00e050;
}

.menu-link.active .menu-title,
.menu-link.router-link-active .menu-title {
  color: #00e050;
  font-weight: 600;
}

/* ========== Footer Section ========== */
.app-sidebar-footer {
  border-top: 1px solid rgba(0, 224, 80, 0.08);
  padding: 12px !important;
}

.app-sidebar-footer .btn-primary {
  background: linear-gradient(135deg, #ff4757 0%, #ff2d3b 100%) !important;
  border: none !important;
  border-radius: 8px !important;
}

.app-sidebar-footer .btn-label {
  color: #fff !important;
  font-weight: 600;
}

/* ========== Mobile / Small Screens ========== */
@media (max-width: 991.98px) {
  .app-sidebar {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    left: auto !important;
    z-index: 1050 !important;
    width: 260px !important;
    height: 100vh !important;
    transform: translateX(100%);
    transition: transform 0.3s ease !important;
  }

  .app-sidebar.drawer-on {
    transform: translateX(0) !important;
  }

  .app-sidebar-logo {
    padding: 12px !important;
  }

  .menu-item {
    margin: 1px 6px;
  }

  .menu-link {
    padding: 10px 12px !important;
  }

  .menu-icon .svg-icon {
    width: 34px;
    height: 34px;
    min-width: 34px;
    min-height: 34px;
  }

  .menu-title {
    font-size: 0.95rem;
  }
}

/* ========== Mia Icon ========== */
.mia-icon-sidebar {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* ========== Legacy Styles ========== */
.main-menu .navbar-header .navbar-brand .brand-logo img {
  max-width: 180px;
}

.main-menu .navbar-header {
  height: auto;
}
</style>

<style>
/* ========== Sidebar Scrollbar (unscoped, overrides Metronic theme) ========== */
#kt_app_sidebar,
#kt_app_sidebar .app-sidebar-menu,
#kt_app_sidebar .hover-scroll-overlay-y,
#kt_app_sidebar .hover-scroll-overlay-y:hover {
  scrollbar-width: auto !important;
  scrollbar-color: #0dbb59 #052112 !important;
}

#kt_app_sidebar .hover-scroll-overlay-y {
  overflow-y: auto !important;
}

#kt_app_sidebar ::-webkit-scrollbar,
#kt_app_sidebar::-webkit-scrollbar {
  width: 12px !important;
}

#kt_app_sidebar ::-webkit-scrollbar-track,
#kt_app_sidebar::-webkit-scrollbar-track {
  background: #052112 !important;
  border-radius: 999px !important;
  border: 1px solid rgba(4, 96, 38, 0.7) !important;
}

#kt_app_sidebar ::-webkit-scrollbar-thumb,
#kt_app_sidebar::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #0b3d1e, #0e6d37, #12a44c) !important;
  background-color: #0e6d37 !important;
  border-radius: 999px !important;
  border: 2px solid #021308 !important;
  background-clip: border-box !important;
}

#kt_app_sidebar ::-webkit-scrollbar-thumb:hover,
#kt_app_sidebar::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #135226, #0f7b3b, #17c25a) !important;
  background-color: #0f7b3b !important;
}

#kt_app_sidebar ::-webkit-scrollbar-corner,
#kt_app_sidebar::-webkit-scrollbar-corner {
  background: transparent !important;
}
</style>
